import { FC, useCallback, useEffect, useState } from 'react';

import { useBusinessToolAiContext } from '../BusinessToolAiProvider';
import { useAIActionHandler } from '../BusinessToolAiProvider/hooks/useAIActionHandler';

export const AiContentGenerationObserver: FC = () => {
  const [isOriginalRequest, setIsOriginalRequest] = useState(true);

  const { isLoading } = useBusinessToolAiContext();
  const { handleActionWithAICheck } = useAIActionHandler();

  const handleClick = useCallback(
    (event: MouseEvent) => {
      if (!isOriginalRequest) {
        setIsOriginalRequest(true);
        return;
      }
      if (!isLoading) return;

      const target = event.target as HTMLElement;

      event.preventDefault();
      event.stopPropagation();

      handleActionWithAICheck(() => {
        setIsOriginalRequest(false);
        setTimeout(() => {
          target.click();
        }, 0);
      });
    },
    [isLoading, handleActionWithAICheck],
  );

  useEffect(() => {
    const header = document.querySelector('header');

    header?.addEventListener('click', handleClick);

    return () => {
      header?.removeEventListener('click', handleClick);
    };
  }, [handleClick]);

  return null;
};
